import React from 'react';
import { Outlet } from 'react-router-dom';
import { IChildrenProp } from 'types/components/components.interface';
import { TopbarPage } from '..';

interface ITopbarTabsTemplateProps extends IChildrenProp {}

const TopbarTabsTemplate = ({ children }: ITopbarTabsTemplateProps) => {
  return (
    <TopbarPage topbar={children}>
      <Outlet />
    </TopbarPage>
  );
};

export default TopbarTabsTemplate;
